module.exports = __webpack_public_path__ + "img/profile.888a3f2d.svg";